var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "coupon-category-app-container",
      staticStyle: { position: "relative", height: "100%" },
    },
    [
      _c(
        "el-dialog",
        {
          attrs: {
            top: _vm.dialogTopMargin,
            title: "產生簽署檔",
            visible: _vm.dialogVisible,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
            closed: _vm.handleGenerateContractDialogClose,
          },
        },
        [
          _c(
            "el-card",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.dialogLoading,
                  expression: "dialogLoading",
                },
              ],
            },
            [
              _c(
                "el-form",
                { attrs: { model: _vm.generateParams } },
                [
                  _c(
                    "h3",
                    {
                      staticStyle: {
                        "border-bottom": "1px solid #eee",
                        "padding-bottom": "12px",
                      },
                    },
                    [
                      _vm._v(" 合約檔名："),
                      _c(
                        "a",
                        {
                          staticStyle: {
                            color: "#1890ff",
                            "font-weight": "400",
                          },
                          attrs: {
                            href: _vm.generateParams.fileLink,
                            target: "_blank",
                          },
                        },
                        [
                          _vm._v(_vm._s(_vm.generateParams.fileName) + " "),
                          _c("i", { staticClass: "el-icon-download" }),
                        ]
                      ),
                    ]
                  ),
                  _c(
                    "el-form-item",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value:
                            !_vm.generateContracts ||
                            _vm.generateContracts.length == 0,
                          expression:
                            "!generateContracts || generateContracts.length == 0",
                        },
                      ],
                      attrs: {
                        label: "簽署檔份數",
                        prop: "generateCount",
                        rules: [
                          {
                            required: true,
                            message: "請輸入要產生的合約簽署檔份數",
                            trigger: "blur",
                          },
                        ],
                      },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { "max-width": "90px" },
                          attrs: {
                            placeholder: "請輸入要產生的合約簽署檔份數",
                          },
                          model: {
                            value: _vm.generateParams.generateCount,
                            callback: function ($$v) {
                              _vm.$set(_vm.generateParams, "generateCount", $$v)
                            },
                            expression: "generateParams.generateCount",
                          },
                        },
                        _vm._l(100, function (item) {
                          return _c("el-option", {
                            key: item,
                            attrs: { label: item, value: item },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value:
                        _vm.generateContracts &&
                        _vm.generateContracts.length > 0,
                      expression:
                        "generateContracts && generateContracts.length > 0",
                    },
                  ],
                },
                [
                  _c(
                    "el-table",
                    {
                      attrs: {
                        data: _vm.generateContracts,
                        border: "",
                        size: "small",
                        height: "200px",
                        stripe: "",
                      },
                    },
                    [
                      _c("el-table-column", {
                        attrs: { align: "center", label: "項次", width: "60" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c("span", [_vm._v(_vm._s(scope.$index + 1))]),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          property: "contractLink",
                          label: "簽署檔連結",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c(
                                  "a",
                                  {
                                    staticStyle: { color: "#20a0ff" },
                                    attrs: {
                                      href: scope.row.contractLink,
                                      target: "_blank",
                                    },
                                  },
                                  [_vm._v(_vm._s(scope.row.contractLink))]
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c("el-table-column", {
                        attrs: { align: "center", label: "複製", width: "130" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c("el-button", {
                                  attrs: {
                                    size: "mini",
                                    icon: "el-icon-copy-document",
                                    circle: "",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.handleClipboard(
                                        scope.row.contractLink,
                                        $event
                                      )
                                    },
                                  },
                                }),
                              ]
                            },
                          },
                        ]),
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value:
                        !_vm.generateContracts ||
                        _vm.generateContracts.length == 0,
                      expression:
                        "!generateContracts || generateContracts.length == 0",
                    },
                  ],
                  staticStyle: { color: "#4b4b4b" },
                  attrs: { type: "warning", loading: _vm.dialogLoading },
                  on: { click: _vm.handleGenerateContract },
                },
                [_vm._v("產 生")]
              ),
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.dialogVisible = false
                    },
                  },
                },
                [
                  _vm._v(
                    _vm._s(
                      _vm.generateContracts && _vm.generateContracts.length > 0
                        ? "關 閉"
                        : "取 消"
                    )
                  ),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "【" + _vm.detail.title + "】合約簽署檔",
            visible: _vm.dialogDetailVisible,
            width: "80%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogDetailVisible = $event
            },
          },
        },
        [
          _c(
            "el-card",
            [
              _c(
                "el-table",
                {
                  ref: "detailTable",
                  staticStyle: { width: "100%" },
                  attrs: {
                    size: "mini",
                    data: _vm.detail.data || [],
                    border: "",
                    stripe: "",
                    height: "400",
                  },
                },
                [
                  _c("el-table-column", {
                    attrs: { align: "center", label: "項次", width: "60" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [_vm._v(" " + _vm._s(scope.$index + 1) + " ")]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      align: "center",
                      label: "ID",
                      prop: "signatureId",
                      width: "60",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: { align: "center", label: "填寫者" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(" " + _vm._s(scope.row.client || "-")),
                            _c("br"),
                            _c(
                              "el-tag",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: !!scope.row.browserId,
                                    expression: "!!scope.row.browserId",
                                  },
                                ],
                                attrs: { type: "info", size: "mini" },
                              },
                              [_vm._v(_vm._s(scope.row.browserId))]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      align: "center",
                      label: "建立時間",
                      prop: "buildDate",
                      width: "130",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "expiredDate",
                      align: "center",
                      label: "失效日期",
                      width: "130",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "el-tag",
                              {
                                attrs: {
                                  effect: "plain",
                                  type: scope.row.expiredDate
                                    ? "danger"
                                    : "primary",
                                },
                              },
                              [
                                _vm._v(
                                  _vm._s(scope.row.expiredDate || "無時效")
                                ),
                              ]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { align: "center", label: "簽署時間", width: "130" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "div",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: !scope.row.signedDate,
                                    expression: "!scope.row.signedDate",
                                  },
                                ],
                              },
                              [_vm._v("-")]
                            ),
                            _c(
                              "el-tag",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: !!scope.row.signedDate,
                                    expression: "!!scope.row.signedDate",
                                  },
                                ],
                                attrs: { type: "info" },
                              },
                              [_vm._v(_vm._s(scope.row.signedDate))]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { align: "center", label: "簽署狀態", width: "130" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            scope.row.signatureStatus === 1
                              ? _c(
                                  "a",
                                  {
                                    attrs: {
                                      href: scope.row.fileInfo.url,
                                      target: "_blank",
                                    },
                                  },
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          size: "mini",
                                          type: "success",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              scope.row.signatureStatusDesc
                                            ) +
                                            " "
                                        ),
                                        _c("i", {
                                          staticClass: "el-icon-download",
                                        }),
                                      ]
                                    ),
                                  ],
                                  1
                                )
                              : scope.row.signatureStatus === 2
                              ? _c(
                                  "el-button",
                                  {
                                    attrs: { size: "mini", type: "primary" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.handleClipboard(
                                          scope.row.contractLink,
                                          $event
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(scope.row.signatureStatusDesc) +
                                        " "
                                    ),
                                    _c("i", {
                                      staticClass: "el-icon-copy-document",
                                    }),
                                  ]
                                )
                              : _c(
                                  "el-tag",
                                  { attrs: { effect: "plain", type: "info" } },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(scope.row.signatureStatusDesc) +
                                        " "
                                    ),
                                  ]
                                ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { align: "center", label: "操作", width: "80" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "div",
                              [
                                _c(
                                  "el-button",
                                  {
                                    attrs: { size: "mini", type: "danger" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.handleDeleteSignContract(
                                          scope.row.signatureId
                                        )
                                      },
                                    },
                                  },
                                  [_vm._v("刪除")]
                                ),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.dialogDetailVisible = false
                    },
                  },
                },
                [_vm._v("關 閉")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-form",
        {
          staticClass: "search-form",
          attrs: { inline: true },
          nativeOn: {
            submit: function ($event) {
              $event.preventDefault()
            },
          },
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "查詢" } },
            [
              _c("el-input", {
                attrs: { placeholder: "請輸入合約檔名" },
                nativeOn: {
                  keyup: function ($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    ) {
                      return null
                    }
                    return _vm.getList($event)
                  },
                },
                model: {
                  value: _vm.listQuery.qry,
                  callback: function ($$v) {
                    _vm.$set(_vm.listQuery, "qry", $$v)
                  },
                  expression: "listQuery.qry",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "簽署狀態" } },
            [
              _c(
                "el-select",
                {
                  model: {
                    value: _vm.listQuery.status,
                    callback: function ($$v) {
                      _vm.$set(_vm.listQuery, "status", $$v)
                    },
                    expression: "listQuery.status",
                  },
                },
                _vm._l(
                  [
                    { key: null, val: "全部" },
                    { key: 1, val: "已簽署" },
                    { key: 2, val: "未簽署" },
                    { key: 3, val: "已結束" },
                  ],
                  function (item) {
                    return _c("el-option", {
                      key: item.key,
                      attrs: { label: item.val, value: item.key },
                    })
                  }
                ),
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            [
              _c("el-button", {
                staticStyle: { "margin-left": "5px" },
                attrs: {
                  type: "primary",
                  icon: "el-icon-search",
                  circle: "",
                  disabled: _vm.listLoading,
                },
                on: { click: _vm.getList },
              }),
              _c("addContractDialog", {
                staticStyle: { display: "inline-block" },
                attrs: { loading: _vm.listLoading },
                on: {
                  "on-refresh": function ($event) {
                    return _vm.refresh()
                  },
                },
              }),
              _c("el-button", {
                staticStyle: { cursor: "pointer" },
                attrs: {
                  type: "success",
                  loading: _vm.listLoading,
                  circle: "",
                  icon: "el-icon-refresh-left",
                },
                on: {
                  click: function ($event) {
                    return _vm.refresh()
                  },
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticStyle: { position: "relative", height: "80%" } },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.listLoading,
                  expression: "listLoading",
                },
              ],
              ref: "contractUploadTable",
              staticStyle: { width: "100%" },
              attrs: {
                size: "mini",
                data: _vm.list,
                border: "",
                height: "100%",
              },
            },
            [
              _c("el-table-column", {
                attrs: { align: "center", label: "項次", width: "60" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [_c("span", [_vm._v(_vm._s(scope.$index + 1))])]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "合約檔名", width: "200", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "a",
                          {
                            staticStyle: { color: "#1890ff" },
                            attrs: {
                              href: scope.row.fileInfo.originalUrl,
                              target: "_blank",
                            },
                          },
                          [
                            _vm._v(" " + _vm._s(scope.row.name) + " "),
                            _c("i", { staticClass: "el-icon-download" }),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  align: "center",
                  label: "建立時間",
                  prop: "buildDate",
                  width: "130",
                },
              }),
              _c("el-table-column", {
                attrs: { align: "center", label: "連結時效性", width: "130" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-tag",
                          {
                            attrs: {
                              effect: "plain",
                              type: scope.row.type == 2 ? "primary" : "danger",
                            },
                          },
                          [_vm._v(_vm._s(scope.row.typeDesc) + " ")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { align: "center", label: "簽署檔", width: "150" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _c(
                          "el-tag",
                          {
                            staticStyle: {
                              "min-width": "60px",
                              "font-size": "20px",
                              "font-weight": "bold",
                              cursor: "pointer",
                            },
                            attrs: { type: "success" },
                            on: {
                              click: function ($event) {
                                return _vm.handleDetailDialog(row)
                              },
                            },
                          },
                          [
                            _vm._v(
                              _vm._s(
                                row.contractSignatures
                                  ? row.contractSignatures.length
                                  : 0
                              ) + " "
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { align: "center", label: "產生簽署檔", width: "130" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: { size: "mini", type: "success" },
                            on: {
                              click: function ($event) {
                                return _vm.handleGenerateContractDialog(
                                  scope.row.id,
                                  scope.row.name,
                                  scope.row.fileInfo.originalUrl
                                )
                              },
                            },
                          },
                          [_vm._v("產生簽署檔")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { align: "center", label: "刪除", width: "130" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: { size: "mini", type: "danger" },
                            on: {
                              click: function ($event) {
                                return _vm.handleDeleteContract(
                                  scope.row.id,
                                  scope.row.name
                                )
                              },
                            },
                          },
                          [_vm._v("刪除")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c("pagination", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.total > 0,
            expression: "total > 0",
          },
        ],
        attrs: {
          layout: "prev, pager, next",
          total: _vm.total,
          page: _vm.listQuery.page,
          limit: _vm.listQuery.limit,
        },
        on: {
          "update:page": function ($event) {
            return _vm.$set(_vm.listQuery, "page", $event)
          },
          "update:limit": function ($event) {
            return _vm.$set(_vm.listQuery, "limit", $event)
          },
          pagination: _vm.getList,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }